<template>
  <Card
    :title="post.title"
    :link="post.link"
    :image="post.featuredImage"
    :caption="showCategory ? post.category.name : ''"
    :caption-size="categorySize"
    :show-gradient="true"
    :type="type"
  >
    <template #content>
      <p class="text-sm text-gray-500">
        {{ post.date | formatDate }}
      </p>
      <div v-dompurify-html="post.excerpt" class="pt-4"></div>
    </template>
    <template #footer>
      <span
        class="flex items-center pt-4 font-bold uppercase text-navitem text-blue cursor-pointer"
        @click="onReadArticle(post.link)"
      >
        Leggi articolo
        <SvgIcon name="angle-right-blue" class="ml-4 max-h-5 max-w-5" />
      </span>
    </template>
  </Card>
</template>

<script>
import Card from '~/components/News/Card.vue'

export default {
  components: {
    Card,
  },
  filters: {
    formatDate(date) {
      const d = new Date(date)
      return `${d.getDate()}.${d.getMonth() + 1}.${d.getFullYear()}`
    },
  },
  props: {
    post: {
      type: Object,
      required: true,
    },
    showCategory: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: 'vertical',
    },
    categorySize: {
      type: String,
      default: 'large',
    },
  },
  methods: {
    onReadArticle(link) {
      this.$router.push(link)
    },
  },
}
</script>
